export const InvoiceState = {
  PAID: 'PAID',
  UNPAID: 'UNPAID'
}
